import { isCharity } from '../../utils/typeGuards';
import useBasePageQuery from '../useBasePageQuery';

export function useCharity() {
  const { data } = useBasePageQuery();

  const charities = data?.page?.relationships?.beneficiaries.nodes.filter(
    isCharity,
  );
  const name = charities?.[0]?.name ?? null;
  const countryCode = charities?.[0]?.countryCode ?? null;
  const profilePageUrl = charities?.[0]?.profilePageUrl ?? null;
  const isNonUKCharity = countryCode !== 'GB';
  const displayName = charities?.[0]?.displayName ?? null;

  return {
    name,
    countryCode,
    displayName,
    profilePageUrl,
    isNonUKCharity,
  };
}
